import { render } from "./ModalPrompt.vue?vue&type=template&id=3b8d4152&scoped=true"
import script from "./ModalPrompt.vue?vue&type=script&lang=js"
export * from "./ModalPrompt.vue?vue&type=script&lang=js"

import "./ModalPrompt.vue?vue&type=style&index=0&id=3b8d4152&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8d4152"]])

export default __exports__